(function() {
  function initHeader() {
    const header = document.querySelector('.header__container');
    const filterBar = document.querySelector('.collection-filter-bar');
    const announcementBar = document.querySelector('#shopify-section-announcement-bar .announcement-bar__container');
    if (!header) return;

    const passiveOptions = { passive: true };
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isNotCollectionPage = !document.body.classList.contains('template-collection');

    let lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    let lastKnownScrollY = lastScrollY;
    let isTicking = false;

    let headerHeight = header.offsetHeight || 0;
    let announcementHeight = announcementBar ? announcementBar.offsetHeight || 0 : 0;
    let filterBarHeight = filterBar ? filterBar.offsetHeight || 0 : 0;

    const SCROLL_BUFFER = 12; // ignore micro-jitter
    const TOP_EPSILON = 1;
    const DURATION = 0.25;
    const EASE = 'power2.out';

    let isHeaderVisible = true;
    let isAnnouncementVisible = true;

    let headerTween = null;
    let filterTween = null;
    let announcementTween = null;

    function getScrollY() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;
      return y < 0 ? 0 : y;
    }

    function updateHeights() {
      headerHeight = header.offsetHeight || 0;
      announcementHeight = announcementBar ? announcementBar.offsetHeight || 0 : 0;
      filterBarHeight = filterBar ? filterBar.offsetHeight || 0 : 0;

      document.documentElement.style.setProperty("--announcement-bar-height", announcementHeight + "px");

      const scrollY = getScrollY();
      isAnnouncementVisible = announcementBar ? scrollY <= TOP_EPSILON : false;
      isHeaderVisible = true;

      if (announcementBar) {
        gsap.set(announcementBar, {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          zIndex: 1002,
          willChange: 'transform',
          background: 'black',
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden',
          y: isAnnouncementVisible ? 0 : -announcementHeight
        });
      }

      const headerY = isAnnouncementVisible && announcementBar ? announcementHeight : 0;

      gsap.set(header, {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        zIndex: 1001,
        willChange: 'transform',
        background: 'black',
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
        y: headerY
      });

      if (filterBar) {
        const filterY = isAnnouncementVisible && announcementBar
          ? announcementHeight + headerHeight
          : headerHeight;

        gsap.set(filterBar, {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 4,
          willChange: 'transform',
          background: 'black',
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden',
          y: filterY
        });

        filterBar.classList.add('is-fixed');

        const contentBelowFilter = filterBar.nextElementSibling;
        if (contentBelowFilter) {
          const offset = headerHeight + filterBarHeight + announcementHeight;
          contentBelowFilter.style.paddingTop = offset + 'px';
        }
      }

      updateHeaderStyles(true);
    }

    function updateHeaderStyles(visible) {
      const styles = { background: visible ? 'black' : 'transparent' };

      gsap.to(header, {
        ...styles,
        duration: DURATION,
        ease: EASE
      });

      if (filterBar) {
        gsap.to(filterBar, {
          ...styles,
          duration: DURATION,
          ease: EASE
        });
      }

      if (isTouchDevice && isNotCollectionPage) {
        if (visible && getScrollY() > 50) {
          header.classList.add('fff');
        } else {
          header.classList.remove('fff');
        }
      }
    }

    function setAnnouncementVisible(visible, animate) {
      if (!announcementBar) return;
      if (visible === isAnnouncementVisible && !animate) return;

      isAnnouncementVisible = visible;

      if (announcementTween) announcementTween.kill();

      const targetY = visible ? 0 : -announcementHeight;

      if (animate) {
        announcementTween = gsap.to(announcementBar, {
          y: targetY,
          duration: DURATION,
          ease: EASE
        });
      } else {
        gsap.set(announcementBar, { y: targetY });
      }

      animateHeader(isHeaderVisible, true);
    }

    function animateHeader(shouldBeVisible, force) {
      if (!force && shouldBeVisible === isHeaderVisible) return;

      isHeaderVisible = shouldBeVisible;

      if (headerTween) headerTween.kill();
      if (filterTween) filterTween.kill();

      const headerTargetY = shouldBeVisible
        ? (isAnnouncementVisible && announcementBar ? announcementHeight : 0)
        : -headerHeight;

      headerTween = gsap.to(header, {
        y: headerTargetY,
        duration: DURATION,
        ease: EASE
      });

      if (filterBar) {
        const filterTargetY = shouldBeVisible
          ? (isAnnouncementVisible && announcementBar
              ? announcementHeight + headerHeight
              : headerHeight)
          : 0;

        filterTween = gsap.to(filterBar, {
          y: filterTargetY,
          duration: DURATION,
          ease: EASE
        });
      }

      updateHeaderStyles(shouldBeVisible);
    }

    function onScrollFrame() {
      isTicking = false;

      const currentScrollY = lastKnownScrollY;
      const atTop = currentScrollY <= TOP_EPSILON;
      const wasAtTop = lastScrollY <= TOP_EPSILON;

      const delta = currentScrollY - lastScrollY;
      const isScrollingDown = delta > SCROLL_BUFFER;
      const isScrollingUp = delta < -SCROLL_BUFFER;

      // Announcement bar
      if (atTop && !wasAtTop) {
        setAnnouncementVisible(true, true);
      } else if (!atTop && wasAtTop) {
        setAnnouncementVisible(false, false);
      }

      // Header visibility: hide on down, show on up
      if (atTop) {
        animateHeader(true);
      } else {
        if (isScrollingDown && isHeaderVisible) {
          animateHeader(false);
        } else if (isScrollingUp && !isHeaderVisible) {
          animateHeader(true);
        }
      }

      lastScrollY = currentScrollY;
    }

    function handleScroll() {
      lastKnownScrollY = getScrollY();
      if (!isTicking) {
        isTicking = true;
        requestAnimationFrame(onScrollFrame);
      }
    }

    function handleResize() {
      updateHeights();
      lastScrollY = getScrollY();
      lastKnownScrollY = lastScrollY;
      const atTop = lastScrollY <= TOP_EPSILON;
      if (announcementBar) {
        setAnnouncementVisible(atTop, false);
      }
      animateHeader(true, true);
    }

    function addEventListeners() {
      window.addEventListener('scroll', handleScroll, passiveOptions);
      window.addEventListener('resize', handleResize);
      // Removed touchmove listener to avoid noisy direction flips on iOS
    }

    function init() {
      updateHeights();
      lastScrollY = getScrollY();
      lastKnownScrollY = lastScrollY;

      const atTop = lastScrollY <= TOP_EPSILON;
      if (announcementBar) {
        isAnnouncementVisible = atTop;
        gsap.set(announcementBar, {
          y: isAnnouncementVisible ? 0 : -announcementHeight
        });
      }

      animateHeader(true, true);
      addEventListeners();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  initHeader();
})();
